module.exports = __webpack_public_path__ + "media/src/images/icon__magazinFalsch2-7fabf404d2127176c8595c15517e0ea3.svg";